import {Injectable} from '@angular/core';
import {DefaultUrlSerializer, UrlSegment, UrlSerializer, UrlTree} from '@angular/router';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ArmUrlSerializerService implements UrlSerializer {

  readonly tokenUrl = 'authToken=';
  private defaultSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();
  constructor() {
  }

  parse(url: string): UrlTree {
    if (_.includes(url, this.tokenUrl)) {
      const startIn = url.indexOf(this.tokenUrl);
      const urlTree = this.defaultSerializer.parse('');
      const keyValArr = url.substr(startIn).split('=');
      urlTree.queryParams[keyValArr[0]] = keyValArr[1];
      return urlTree;
    } else {
      return this.defaultSerializer.parse(url);
    }
  }

  serialize(tree: UrlTree): string {
    return this.defaultSerializer.serialize(tree);
  }
}
